import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const WhatsappapiLogin = () => {
  const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
  
    const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();
      setError('');
      $("#waitinggif").show();
      setTimeout(() => {$("#waitinggif").hide();}, 10000);
      try {
        let response = await fetch(`/signup`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({email,password,adminuserid: window.APPSETTING.adminuserid,appname: window.APPSETTING.appname}),
        });
  
        let data = await response.json();
  
        if (!response.ok) {
          if (response.status == 400) {
            response = await fetch(`/login`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({email,password,adminuserid: window.APPSETTING.adminuserid,appname: window.APPSETTING.appname}),
            });
            data = await response.json();
  
            if (!response.ok) {
              throw new Error(data.error || 'Login failed');
            }
          } else {
            throw new Error(data.error || 'Signup failed');
          }
        }
        console.log(data);
        window.APPUSER = data;
        localStorage.setItem(window.APPSETTING.appname + "user",JSON.stringify(window.APPUSER));
        setTimeout(() => {navigate('/dashboard');}, 1000);
      } catch (err: any) {
        setError(err.message);
      }
    };
  
    return (
      <div className="section">
        <div className="container" style={{ display: 'flex', justifyContent: 'center' }}>
          <div className="c-form" style={{ width: '100%', maxWidth: '400px' }}>
            <form onSubmit={handleSubmit}>
              {error && (
  
                <div style={{
                  color: '#d93025', 
                  backgroundColor: '#fce8e6', 
                  padding: '10px', 
                  borderRadius: '4px', 
                  marginBottom: '15px',
                  fontSize: '13px'
                }}>
                  {error}
                </div>
              )}
              
              <div className="fg">
                <label>Email</label>
                <input 
                  type="email" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  required 
                  placeholder="name@firm.com"
                />
              </div>
              
              <div className="fg">
                <label>Password</label>
                <input 
                  type="password" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  required 
                  placeholder="••••••••"
                />
              </div>
              
              <button type="submit" className="btn-blue" style={{ width: '100%', marginTop: '10px' }}>
                Proceed <img id="waitinggif" src="/css/whatsappapi/waiting.gif" style={{display:'none', width:'25px',position:'absolute'}}/>
              </button>
            </form>
          </div>
        </div>
      </div>
    );
};

// CRITICAL FIX: Export the component as default
export default WhatsappapiLogin;
